import React, { Component } from 'react';

import config from 'config';

class WebChat extends Component {
  componentDidMount() {
    if (config.WEBCHAT_COMPANY_ID) {
      const uri = encodeURI(`${config.WEBCHAT_HOST}/sdk.bundle.js?companyId=${config.WEBCHAT_COMPANY_ID}&version=${config.WEBCHAT_VERSION}`);
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'TSChatSDK';
      script.src = uri;
      document.body.appendChild(script);
    }
  }

  render() {
    return (<div />);
  }
}
export default WebChat;



// WEBPACK FOOTER //
// ./src/components/WebChat.jsx